import toggleClass from 'utils/DOM/toggleClass'

function toggleMenu() {
  toggleClass(document.body, 'menu-active')
}

export default toggleMenu
